<div *ngIf="showSaveCancelRow" class="row {{lateralSpacing ? 'px-3' : ''}}">
    <div class="col-12 mb-4">
        <primary-text-button [noLeftPadding]="true"
                             *ngIf="jsonString"
                             (click)="onSave.emit(jsonString)">
            {{'Save' | translate }}
        </primary-text-button>
        <cancelary-text-button (click)="onCancel.emit()" [noRightMargin]=true>
            {{'Cancel' | translate }}
        </cancelary-text-button>
    </div>
</div>
<div class="mb-0 no-gutters row h-100 overflow-hidden w-100 {{lateralSpacing ? 'px-3' : ''}}">
    <div class="col list-determinants h-100 mh-100">
        <determinant-list
            class="d-flex overflow-hidden mh-100 h-100 flex-column flex-grow-0 py-3 pl-3"
            (onAddModalOpened)="onAddModalOpened.emit($event)"
            (onEditModalOpened)="onEditModalOpened.emit($event)"
            [groupsLength]="{value: jsonString}"
            [prefix]="prefix"
            [determinantMapById]="determinantMapById"
            [addDeterminantTo]="_appendDeterminant"
        >
        </determinant-list>
    </div>
    <div class="col pl-2 pb-3 query-builder">
        <ng-content></ng-content>
        <query-builder *ngIf="determinantMapById != null" [determinantMapById]="determinantMapById"  [ngClass]="'fixed scrolleable'"
                       [prefix]="prefix"
                       [jsonString]="jsonString"
                       [noneSelectedText]="noneSelectedText"
                       [noneSelectedSubText]="noneSelectedSubText"
                       (onChange)="onChanged($event);onChange.emit($event)"></query-builder>
    </div>
</div>